module.exports = __webpack_public_path__ + "static/media/island.7b1a48bf.mp4";